module.exports = __webpack_public_path__ + "static/media/PDF_135.c5e2e4dc.pdf";